export enum CustomerSource {
  DataWarehouse = 'DWH',
  MadeToMeasure = 'MTM_APP',
}
